export const SERVICE_PRICE_LIST = {
  "Nail Extensions": {
    columns: ["Full Set", "Infill", "Take Off & Redone"],
    items: [
      {
        name: "Acrylic + Gel Polish",
        prices: ["£37", "£32", "£42"],
      },
      {
        name: "Overlay + Gel Polish",
        prices: ["£35", "£30", "£40"],
      },
      {
        name: "Colour Power",
        prices: ["£37", "£32", "£42"],
      },
      {
        name: "French Tips from",
        prices: ["£40", "£35", "£45"],
      },
      {
        name: "Ombre",
        prices: ["£40", "£35", "£45"],
      },
      {
        name: "Builder Gel (BIAB)",
        displayPrice: "From £32",
        prices: ["From £30", "£30", "£34"],
      },
    ],
  },
  Hands: {
    columns: ["Price"],
    items: [
      { name: "Gel Polish (Shellac)", prices: ["£22"] },
      { name: "Gel French Tips", prices: ["£27"] },
      { name: "Full Manicure", prices: ["£15"] },
      { name: "Full Manicure + Gel", prices: ["£27"] },
    ],
  },
  Toes: {
    columns: ["Price"],
    items: [
      { name: "Gel Polish", prices: ["£23"] },
      { name: "Gel French Tips", prices: ["£28"] },
      { name: "Spa Pedicure", prices: ["£30"] },
      { name: "Spa Pedicure + Shellac", prices: ["£40"] },
      { name: "Toes Extension", prices: ["£35"] },
      { name: "Two Big Toes Extension", prices: ["£10"] },
    ],
  },
  "Take Off": {
    columns: ["Price"],
    items: [
      { name: "Take Off Shellac Hands", prices: ["£10"] },
      { name: "Take Off Acrylics", prices: ["£10"] },
      { name: "Take Off Builder Gel (BIAB)", prices: ["£10"] },
    ],
  },
  Extra: {
    columns: ["Price"],
    items: [
      { name: "Chrome (Metallic)", prices: ["£5"] },
      { name: "Long Nails from", prices: ["£3"] },
      { name: "Gems (set of 10)", prices: ["£3"] },
      { name: "Nail Art Design from", prices: ["£5"] },
    ],
  },
};

export const getServicePrice = (category, serviceName, priceIndex = 0) => {
  const service = SERVICE_PRICE_LIST[category]?.items.find(
    ({ name }) => name === serviceName
  );

  return service?.displayPrice || service?.prices[priceIndex] || "";
};
